export default __webpack_public_path__ + "static/media/FAQ_11_4.d63ab1e3.png";